import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { TargetGroupRequestModel } from '../business-entities/campaign-modal';

@Injectable({
  providedIn: 'root'
})
export class CampaignTemplateDataService {

  constructor(private dataService: DataService) { }

  getAllTemplate(requestModal: TargetGroupRequestModel): Promise<any>{
    return this.dataService.GetForCampaignServicePayload(Urls.Template,requestModal).toPromise();
  }

  getTemplateById(id: any): Promise<any>{
    return this.dataService.GetForCampaignServiceWithParam<any>(Urls.Template,id).toPromise();
  }

  getTemplateByChannel(channel: any): Promise<any>{
    return this.dataService.GetForCampaignServiceWithParam<any>(Urls.Template, 0, channel).toPromise();
  }

  addUpdateTemplate(template: any): Promise<any>{
    return this.dataService.PostForCampaignService<any>(Urls.Template,template).toPromise();
  }

  deleteTemplate(id: any): Promise<any>{
    return this.dataService.DeleteForCampaignService<any>(Urls.Template,id).toPromise();
  }
}
